import type { ProductOffer, PricePoint } from '@pricymayky/shared';

export type HistoryRange='7'|'30'|'90'|'all';
export type HistoryReading=PricePoint & {storeName:string;offerId:string};
export type HistoryGroup={currency:string;series:Array<{key:string;name:string}>;rows:Array<{timestamp:number;[key:string]:number}>;readings:HistoryReading[]};
export function buildPriceHistory(offers:ProductOffer[],range:HistoryRange,isDemo=false,now=Date.now()):HistoryGroup[] {
  const cutoff=range==='all' ? -Infinity:now-Number(range)*86_400_000;
  const groups=new Map<string,HistoryGroup>();
  offers.forEach((offer,index)=>{
    if(['uncertain','rejected'].includes(offer.matchStatus??'verified'))return;
    const points=offer.history.filter(point=>Number.isSafeInteger(point.priceMinor) && point.priceMinor>0
      && Number.isFinite(Date.parse(point.recordedAt)) && Date.parse(point.recordedAt)>=cutoff && Date.parse(point.recordedAt)<=now
      && (point.source==='worker' || isDemo && point.source==='demo') && /^[A-Z]{3}$/.test(point.currency));
    for(const currency of new Set(points.map(point=>point.currency))) {
      const group=groups.get(currency) ?? {currency,series:[],rows:[],readings:[]};
      const key=`offer${index}`;
      const duplicates=offers.filter(other=>other.store.domain.replace(/^www\./,'')===offer.store.domain.replace(/^www\./,'')).length>1;
      group.series.push({key,name:offer.store.name+(duplicates ? ` · oferta ${index+1}`:'')});
      for(const point of points.filter(point=>point.currency===currency)) {
        // No daily aggregation, carry-forward, or invented values between measurements.
        group.rows.push({timestamp:Date.parse(point.recordedAt),[key]:point.priceMinor});
        group.readings.push({...point,storeName:offer.store.name,offerId:offer.id});
      }
      groups.set(currency,group);
    }
  });
  return [...groups.values()].map(group=>{
    const rows:HistoryGroup['rows']=[];
    for(const row of group.rows.toSorted((a,b)=>a.timestamp-b.timestamp)) {
      const previous=rows.at(-1);const key=Object.keys(row).find(key=>key!=='timestamp')!;
      if(previous?.timestamp===row.timestamp && previous[key]===undefined) Object.assign(previous,row); else rows.push({...row});
    }
    return {...group,rows,readings:group.readings.toSorted((a,b)=>Date.parse(a.recordedAt)-Date.parse(b.recordedAt))};
  });
}
